import TextField from '../text_field';
import RatingField from '../rating_field';
import OptionRadioField from '../option_radio_field';
import {PatientSurveyProps, SurveyComponentTypes} from '../../types';

type SurveyItemProps = {
  data: PatientSurveyProps;
  disabled: boolean;
}

export const surveyComponentTypeToFormField = {
  [SurveyComponentTypes.INFO]: ({data}) => <div className="info">{data.label}</div>,
  [SurveyComponentTypes.TEXT]: TextField,
  [SurveyComponentTypes.TEXTAREA]: TextField,
  [SurveyComponentTypes.RADIO]: OptionRadioField,
  [SurveyComponentTypes.RATING_HEADER]: RatingField
};

const SurveyItem = ({data, disabled}: SurveyItemProps) => {
  const {type} = data || {};
  const Component = surveyComponentTypeToFormField[type];

  if (!Component) {
    return null;
  }

  return (
    <Component data={data} disabled={disabled}/>
  );
};

export default SurveyItem;
